import { render } from "./AppForm.vue?vue&type=template&id=194f5c0c&lang=pug"
import script from "./AppForm.vue?vue&type=script&lang=js"
export * from "./AppForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\projects\\phpstorm\\projects_pasha_atunin\\conditioner\\public_html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__